import React from 'react';
import styles from './Header.module.scss';

export default function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src="/images/2025/1095 - Circle of Excellence_Colored_White_300x72.png" alt="Circle of Excellence" />
          </div>
        </div>
      </div>
    </header>
  );
}